// extracted by mini-css-extract-plugin
export default {"image_section":"UnderConstruction_image_section__oCOWy","content_section":"UnderConstruction_content_section__p4Y3j"};